<template>
  <div id="app">
    <AppTemplate />
  </div>
</template>

<script>
import AppTemplate from "./components/AppTemplate.vue";

export default {
  name: "App",
  components: {
    AppTemplate
  },

  mounted() {
    const params = new URLSearchParams(window.location.search);
    const ref = params.get('ref');

    if (ref) window.localStorage.setItem('ref', ref)
  }
};
</script>
